import { useState, useEffect, startTransition } from 'react'

// Persist preferences to localStorage
export function usePersistedState<T>(
  key: string,
  defaultValue: T,
): [T, (value: T) => void] {
  const [state, setState] = useState<T>(defaultValue)

  useEffect(() => {
    const stored = localStorage.getItem(key)
    if (stored) {
      try {
        startTransition(() => {
          setState(JSON.parse(stored))
        })
      } catch {
        // Ignore parse errors
      }
    }
  }, [key])

  const setPersistedState = (value: T) => {
    setState(value)
    localStorage.setItem(key, JSON.stringify(value))
  }

  return [state, setPersistedState]
}
